import { SEVERITIES_FILTER_OPTIONS } from "@/const/options.constants"
import { useSettings } from "@/hooks/useUser"
import { ExportButton } from "@/molecules/ExportButton"
import { Filter } from "@/organisms/FilterNew/Filter"
import { InputSmartSearchLoading, SmartSearch } from "@/organisms/SmartSearch"

import { useFiltersSbom } from "@/pages/DiscoveryPage/application/sbom-inventory/useSbomInventory"

import type { SbomFilterComponent } from "."

export const SbomFilter: SbomFilterComponent = (props) => {
  const {
    searchedVulnerabilities,
    isLoading,
    previewMode,
    exportType,
    isDataAvailable,
    exportQueryParams,
    packagesReferencesCount,
    placement = "sbom-page",
    ...attr
  } = props
  const packagesExportLimit = useSettings("packagesExportLimits")

  const {
    filters,
    filterOptionsData,
    isLoading: isOptionsLoading
  } = useFiltersSbom({
    enabled: !previewMode
  })

  if (previewMode) return null

  const isLoadingFilters = isLoading || isOptionsLoading

  return (
    <Filter.Provider keys={filters} {...attr}>
      <Filter.Template
        isLoading={isLoadingFilters}
        aside={
          <ExportButton
            filters={exportQueryParams?.()}
            isLoading={!isDataAvailable || isLoading}
            exportType={exportType || "Sbom"}
            exceededLimit={(packagesReferencesCount ?? 0) > packagesExportLimit}
            exportLimit={packagesExportLimit}
          />
        }
        search={
          isLoadingFilters ? (
            <InputSmartSearchLoading />
          ) : (
            <SmartSearch
              id="smart-search-sbom-tab-inventory"
              filters={filters}
              data={filterOptionsData}
              searchedVulnerabilities={searchedVulnerabilities}
            />
          )
        }
      >
        <Filter.Insights
          filters={filters}
          isLoading={isLoadingFilters}
          placement={placement}
        />
        <Filter.Checkbox
          isLoading={isLoadingFilters}
          order="none"
          keyFilter="severity"
          items={SEVERITIES_FILTER_OPTIONS}
          placeHolderDefaultValue="Severity"
          placement={placement}
        />
      </Filter.Template>
    </Filter.Provider>
  )
}
